"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const v0_29_1 = require("./v0-29");
const v0_31_1 = require("./v0-31");
/**
 * Returns an Adaptor implementation for a given tendermint version.
 * Throws when version is not supported.
 *
 * @param version full Tendermint version string, e.g. "0.20.1"
 */
function adaptorForVersion(version) {
    if (version.startsWith("0.29.") || version.startsWith("0.30.")) {
        return v0_29_1.v0_29;
    }
    else if (version.startsWith("0.31.")) {
        return v0_31_1.v0_31;
    }
    else {
        throw new Error(`Unsupported tendermint version: ${version}`);
    }
}
exports.adaptorForVersion = adaptorForVersion;
//# sourceMappingURL=adaptorforversion.js.map